export default function HowItWorksCard() {
  return (
    <aside className="border border-black p-5 md:p-6 bg-zinc-50">
      <p className="font-mono text-[10px] uppercase tracking-[0.3em] opacity-70 mb-2">
        How it works
      </p>
      <ol className="space-y-3 text-sm">
        <li className="flex gap-3">
          <span className="font-mono text-xs border border-black w-5 h-5 inline-flex items-center justify-center">1</span>
          <span>Upload PDFs or a ZIP archive of crash reports.</span>
        </li>
        <li className="flex gap-3">
          <span className="font-mono text-xs border border-black w-5 h-5 inline-flex items-center justify-center">2</span>
          <span>
            Gemini vision reads the <span className="font-mono">All Drivers &amp; Occupants</span> page
            {" "}<em>and</em> every <span className="font-mono">Non-Motorist</span> page.
          </span>
        </li>
        <li className="flex gap-3">
          <span className="font-mono text-xs border border-black w-5 h-5 inline-flex items-center justify-center">3</span>
          <span>
            We keep injury codes <span className="font-mono">01 / 02 / 03 / 04</span> —
            {" "}<span className="font-mono">04</span> is split by ambulance transport.
          </span>
        </li>
      </ol>
    </aside>
  );
}
